import { Component, effect, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { SplitterModule } from 'primeng/splitter';
import { ToolbarComponent } from '../../../organisms/toolbar/toolbar.component';
import { TopBarComponent } from '../../../organisms/top-bar/top-bar.component';
import { ToolbarItem } from '../../../../models/toolbar-item';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { SidebarService } from '../../../../services/menu/sidebar.service';
import { getState } from '@ngrx/signals';
import {
  AtlasEventCallback,
  GlobalsStore,
} from '../../../../stores/globals.state';
import { filter } from 'rxjs';
import { ActiveUserStore } from '../../../../stores/user/active-user.state';
import { DataLayerTypeAdministrationComponent } from '../../../organisms/data-layer-type-administration/data-layer-type-administration.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { BasicMapComponent } from '../../../molecules/basic-map/basic-map.component';
import { IndicatorDetailComponent } from '../../../organisms/indicator-detail/indicator-detail.component';
import { AlertComponent } from '../../../atoms/alert/alert.component';
import { ButtonModule } from 'primeng/button';
import { IndicatorDataDetailComponent } from '../../../organisms/indicator-data-detail/indicator-data-detail.component';
import { RoutingService } from '../../../../services/routing.service';
import { ToastModule } from 'primeng/toast';
import { ConfirmDeleteDataLayerComponent } from '../../../molecules/confirm-delete-data-layer/confirm-delete-data-layer.component';
import { ConfirmDeleteDataLayerTypeComponent } from '../../../molecules/confirm-delete-data-layer-type/confirm-delete-data-layer-type.component';
import { ConfirmDeleteIndicatorComponent } from '../../../molecules/confirm-delete-indicator/confirm-delete-indicator.component';
import { ConfirmDeleteCategoryComponent } from '../../../molecules/confirm-delete-category/confirm-delete-category.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmDeleteBookmarkCategoryComponent } from '../../../molecules/confirm-delete-bookmark-category/confirm-delete-bookmark-category.component';
import { HeaderComponent } from '../../../atoms/header/header.component';
import { SidebarModule } from 'primeng/sidebar';
import { HelpButtonComponent } from '../../../molecules/help-button/help-button.component';
import { DialogModule } from 'primeng/dialog';
import { DataLayerFormComponent } from '../../../organisms/data-layer-form/data-layer-form.component';
import { BookmarkCategoryFormComponent } from '../../../organisms/bookmark-category-form/bookmark-category-form.component';
import { ColorsetFormComponent } from '../../../organisms/colorset-form/colorset-form.component';
import { DividerModule } from 'primeng/divider';
import { IndicatorDataListComponent } from '../../../molecules/indicator-data-list/indicator-data-list.component';
import { RoleBasedHandler } from '../../../../handlers/role-based-handler';
import { IndicatorStore } from '../../../../stores/indicator/indicator.state';
import { WorkspaceFormComponent } from '../../../organisms/workspace-form/workspace-form.component';
import { IndicatorData } from '../../../../models/indicator-data';
import { MaskComponent } from '../../../organisms/mask/mask.component';
import { OverviewTableIndicatorComponent } from '../../../organisms/overview-table-indicator/overview-table-indicator.component';
import { ConfirmPublicationDataLayerComponent } from '../../../molecules/confirm-publication-data-layer/confirm-publication-data-layer.component';
import { ConfirmPublishDataComponent } from '../../../molecules/confirm-publish/confirm-publish-data.component';
import { ConfirmDeleteBookmarkLinkComponent } from '../../../molecules/confirm-delete-bookmark-link/confirm-delete-bookmark-link.component';
import { ConfirmDisableBookmarkLinkComponent } from '../../../molecules/confirm-disable-bookmark-link/confirm-disable-bookmark-link.component';
import { BookmarkValidationService } from '../../../../services/bookmark-validation.service';
import { BookmarkStore } from '../../../../stores/bookmark/bookmark.state';

@Component({
  selector: 'app-authenticated-view',
  standalone: true,
  imports: [
    NgIf,
    SharedModule,
    SplitterModule,
    ToolbarComponent,
    TopBarComponent,
    DataLayerTypeAdministrationComponent,
    ScrollPanelModule,
    BasicMapComponent,
    IndicatorDetailComponent,
    AlertComponent,
    ButtonModule,
    RouterLink,
    IndicatorDataDetailComponent,
    ToastModule,
    ConfirmDeleteDataLayerComponent,
    ConfirmDeleteDataLayerTypeComponent,
    ConfirmDeleteIndicatorComponent,
    ConfirmDeleteCategoryComponent,
    ConfirmDialogModule,
    ConfirmDeleteBookmarkCategoryComponent,
    HeaderComponent,
    RouterOutlet,
    SidebarModule,
    HelpButtonComponent,
    DialogModule,
    DataLayerFormComponent,
    BookmarkCategoryFormComponent,
    ColorsetFormComponent,
    DividerModule,
    IndicatorDataListComponent,
    WorkspaceFormComponent,
    MaskComponent,
    OverviewTableIndicatorComponent,
    ConfirmPublicationDataLayerComponent,
    ConfirmPublishDataComponent,
    ConfirmDeleteBookmarkLinkComponent,
    ConfirmDisableBookmarkLinkComponent,
  ],
  templateUrl: './authenticated-view.component.html',
  styleUrl: './authenticated-view.component.scss',
})
export class AuthenticatedViewComponent {
  readonly globalStore = inject(GlobalsStore);
  readonly userStore = inject(ActiveUserStore);
  readonly indicatorStore = inject(IndicatorStore);
  readonly roleBasedHandler = inject(RoleBasedHandler);
  readonly bookmarkValidationService = inject(BookmarkValidationService);
  readonly bookmarkStore = inject(BookmarkStore);

  protected storesInitialized = false;
  protected validationInitialized = false;
  public openSidebar = false;
  public addNewLayerDialogWithType?: string;
  public addWorkspaceDialog = '';
  public addNewColorsetDialog = false;
  public addNewBookmarkCategoryDialog = false;
  public openDataList = false;
  public activeIndicatorData?: IndicatorData;

  toolbarItems: ToolbarItem[] = [
    {
      icon: 'fas fa-cloud-upload',
      key: 'importExport',
      routerLink: ['/data-backend', { outlets: { overlay: 'cloud' } }],
      label: `Import / Export`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-folder-tree',
      key: 'indicators',
      routerLink: ['/data-backend', { outlets: { overlay: 'indikatoren' } }],
      label: `Indikatorenverzeichnis`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-pen-ruler',
      key: 'pool',
      routerLink: ['/data-backend', { outlets: { overlay: 'vorlagen' } }],
      label: `Indikatorenvorlagen`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-note-sticky',
      key: 'bookmarks',
      routerLink: ['/data-backend', { outlets: { overlay: 'lesezeichen' } }],
      label: `Ansichten`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-file-lines',
      key: 'stories',
      routerLink: ['/data-backend', { outlets: { overlay: 'berichte' } }],
      label: `Berichte`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-book-open',
      key: 'themes',
      routerLink: ['/data-backend', { outlets: { overlay: 'themen' } }],
      label: `Themen`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-list-check',
      key: 'massActions',
      routerLink: [
        '/data-backend',
        { outlets: { overlay: 'sammel-aktionen' } },
      ],
      label: `Sammelaktionen`,
      tooltip: ``,
    },
    //{
    //  icon: 'fas fa-globe',
    //  key: 'publish',
    //  routerLink: [
    //    '/data-backend',
    //    { outlets: { overlay: 'veröffentlichung' } },
    //  ],
    //  label: `Veröffentlichen`,
    //  tooltip: ``,
    //},
    {
      icon: 'fas fa-palette',
      key: 'colorsets',
      routerLink: ['/data-backend', { outlets: { overlay: 'farbsets' } }],
      label: `Farbsets`,
      tooltip: ``,
    },
    {
      icon: 'fas fa-gears',
      key: 'config',
      routerLink: ['/data-backend', { outlets: { overlay: 'konfiguration' } }],
      label: `Atlaskonfiguration`,
      tooltip: ``,
    },
    //{
    //  icon: 'fas fa-clock-rotate-left',
    //  key: 'history',
    //  routerLink: ['/data-backend', { outlets: { overlay: 'historie' } }],
    //  label: `Historie`,
    //  tooltip: `History`,
    //},
  ];

  constructor(
    private router: Router,
    protected sidebarService: SidebarService,
    protected routingService: RoutingService
  ) {
    this.openSidebar = false;
    this.setRouterEvents();
    this.userStore.checkAuthStatus();
    effect(() => {
      this.activeIndicatorData = this.globalStore.getActiveIndicatorData();

      // set global selected dataLayer and dataLayerType
      if (
        !this.storesInitialized &&
        !this.roleBasedHandler.areStoresInitialized()
      )
        return;
      this.storesInitialized = true;
      queueMicrotask(() => this.roleBasedHandler.performInitialization());

      // Run initial bookmark validation after stores are initialized
      if (!this.validationInitialized && this.userStore.canAccessConfig()) {
        this.validationInitialized = true;
        this.runInitialValidation();
      }

      const globalState = getState(this.globalStore);

      if (globalState.atlasEventCallback) {
        this.globalEventCallback(globalState.atlasEventCallback);
      }
    });
  }

  /**
   * Runs initial validation of all public bookmarks
   * Only runs once after stores are initialized and if user has config access
   */
  private runInitialValidation(): void {
    // Small delay to ensure all stores are fully loaded
    setTimeout(() => {
      const bookmarks = this.bookmarkStore.asArray();
      if (bookmarks.length > 0) {
        const summary =
          this.bookmarkValidationService.validatePublicBookmarks(bookmarks);
        this.globalStore.setBookmarkValidation(summary);

        // Optional: Show a toast notification if issues are found
        if (summary.invalidBookmarks > 0) {
          console.log(
            `⚠️ Bookmark Validation: ${summary.invalidBookmarks} bookmark(s) with ${summary.totalIssues} issue(s) found`
          );
        }
      }
    }, 500);
  }

  /**
   * Handles the closing of an overlay by navigating to a sanitized redirect URL.
   *
   * The method determines the redirect URL based on the current router URL. If the URL contains
   * parameters (indicated by a semicolon), it splits and selects the portion before the parameters.
   * Otherwise, it takes the second segment of the URL path. Finally, it navigates to the computed redirect URL.
   *
   * @return {void} This method does not return a value.
   */
  onOverlayClose(): void {
    const url = this.router.url;
    const redirectUrl =
      url.indexOf(';') > -1
        ? this.router.url.split(';')[0]
        : this.router.url.split('/')[1]; // workaround - bad practise
    this.router.navigateByUrl(redirectUrl);
  }

  /**
   * Subscribes to the router events and triggers specific actions based on navigation events.
   * It filters navigation events to listen only for `NavigationEnd` type events.
   * Updates the state of `openSidebar` based on the presence of a specific pattern in the navigation URL.
   *
   * @return {void} Does not return any value.
   */
  setRouterEvents(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.openSidebar = event.url.toString().indexOf('(overlay:') > -1;
      });
  }

  /**
   * Handles global event callbacks and updates corresponding dialog states or properties
   * based on the event key provided in the AtlasEventCallback object.
   *
   * @param {AtlasEventCallback} atlasEventCallback The event callback object containing
   *        the event key and additional options for the callback.
   *        - key: The identifier for the specific event, such as 'addLayerDialog',
   *          'addWorkspaceDialog', etc.
   *        - options: Additional data associated with the event, such as data layer type ID or key.
   *
   * @return {void} This method does not return any value.
   */
  private globalEventCallback(atlasEventCallback: AtlasEventCallback): void {
    switch (atlasEventCallback.key) {
      case 'addLayerDialog':
        this.addNewLayerDialogWithType =
          atlasEventCallback.options.dataLayerTypeId;
        break;
      case 'addWorkspaceDialog':
        this.addWorkspaceDialog = atlasEventCallback.options?.key || '';
        break;
      case 'addColorsetDialog':
        this.addNewColorsetDialog = true;
        break;
      case 'addBookmarkCategoryDialog':
        this.addNewBookmarkCategoryDialog = true;
        break;
    }
  }
}
